import { Component } from '@angular/core';
import { RentalsService } from "../../../../../services/rentals.service";
import { HelpersService } from "../../../../../services/helpers.service";
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-rentals-service-indicators-config',
  templateUrl: './rentals-service-indicators-config.component.html',
  styleUrls: ['./rentals-service-indicators-config.component.scss']
})
export class RentalsServiceIndicatorsConfigComponent {

  public serviceIndicatorConfigs : any = [];
  public productCategories : any = [];
  public selectedServiceIndicator : any;
  public showServiceIndicatorConfig : boolean = false;
  public rentalConfig : any = {};
  public loadingConfig : boolean = false;

  public metricOptions = [
    { label: this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_points'), value: 'Points' },
    { label: this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_mileage'), value: 'Mileage' },
    { label: this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_hours'), value: 'Hours' },
    { label: this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_time_interval_days'), value: 'TimeIntervalDays' },
    { label: this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_metric_rental_count'), value: 'RentalCount' }
  ];

  public serviceIndicatorModes = [
    { label: this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_mode_basic'), value: 'basic' },
    { label: this.translate.instant('bikeshop.rentals.service_indicators_config.configuration_mode_advanced'), value: 'advanced' }
  ]

  constructor(
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private translate : TranslateService
  ){

  }

  ngOnInit() {
    this.getServiceIndicatorConfig();
    this.getProductCategories();
  }

  getServiceIndicatorConfig(){   
    this.loadingConfig = true;
    this.rentalsService.getRenalServiceIndicators(this.helpersService.getPartnerId()).subscribe((response: any) => {      
      this.serviceIndicatorConfigs = response;
      this.loadingConfig = false;
    });
  }

  getProductCategories(){
    this.rentalsService.getRentalProductCategories(this.helpersService.getPartnerId()).subscribe((response: any) => {  
      this.productCategories = response;
    });
  }

  getRentalConfig(){
    this.rentalsService.getRentalConfiguration(this.helpersService.getPartnerId()).subscribe((response: any) => {
      this.rentalConfig = response
    });
  }

  addServiceIndicator(){
    this.selectedServiceIndicator = null;
    this.showServiceIndicatorConfig = true;
  }

  updateServiceIndicator(serviceIndicator){
    this.selectedServiceIndicator = serviceIndicator;
    this.showServiceIndicatorConfig = true;
  }

  closeSidebar(){
    this.showServiceIndicatorConfig = false;
    this.selectedServiceIndicator = null;
    this.getServiceIndicatorConfig();
  }

  getServiceIndicatormetricLabel(metric: string) {
    const metricOption = this.metricOptions.find((option: any) => option.value === metric);
    return metricOption ? metricOption.label : metric;
  }

}
